export default "__VITE_ASSET__Csi2xtIH__"